import { Component, signal, OnInit, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DeveloperService } from '../../../../../services/developer.service';
import { Exception, ToasterService } from '@anddone/ui-utilities';
import { MessageConstants } from '../../../../../constants/message.constant';
import { Loader } from '../../../../layout/loader/loader';
import { DatePipe, JsonPipe, NgClass } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { AllyCommonService } from '../../../../../services/ally-common-service';

@Component({
  selector: 'app-webhook-details',
  imports: [DatePipe, NgClass, TranslateModule, JsonPipe, Loader],
  templateUrl: './webhook-details.html',
  styleUrl: './webhook-details.scss',
})
export class WebhookDetails implements OnInit {
  webhookEventLogDetails: any;
  isLoader = signal<boolean>(false);
  responseMessage: any;
  responseType!: string;
  cleanResponse: any;
  eventTypeToShow!: string;
  modifiedResponseMessage: any;
  webhookBodyParsedResponse: any;
  logId: any;
  webhookStatus = 'Accepted';

  private router = inject(Router);
  private developerService = inject(DeveloperService);
  private toasterService = inject(ToasterService);
  private activatedRouter = inject(ActivatedRoute);
  public allyCommonService = inject(AllyCommonService);

  ngOnInit(): void {
    this.logId = this.activatedRouter.snapshot.params['id'];
    this.viewWebHookDetailsGet(this.logId);
  }

  viewWebHookDetailsGet(logId: any) {
    this.isLoader.set(true);
    this.developerService.viewWebhookEventLogAction(logId)?.subscribe({
      next: (res: any) => {
        this.isLoader.set(false);
        this.webhookEventLogDetails = res;
        this.cleanResponse = this.webhookEventLogDetails?.responseMessage?.replace(/\n/g, '');
        this.eventTypeToShow = this.webhookEventLogDetails?.eventName?.replace('.', ' - ');
        this.responseMessage = this.cleanResponse || 'No Data Available';
        this.webhookBodyParsedResponse =
          JSON?.parse(this?.webhookEventLogDetails?.webhookBody) || 'No Data Available';
        if (
          typeof this.webhookEventLogDetails.responseMessage === 'string' &&
          this.webhookEventLogDetails.responseMessage.trim().startsWith('<')
        ) {
          this.responseType = 'html';
          this.modifiedResponseMessage = this.responseMessage.replace(
            /<a /g,
            '<a target="_blank" '
          );
        } else {
          this.responseType = 'other';
        }
        this.webhookStatus = this.webhookEventLogDetails.status;
      },
      error: (e: any) => {
        this.isLoader.set(false);
        const toastMessage = Exception.exceptionMessage(e);
        this.toasterService.showError(toastMessage.join(', '), 'full');
      },
    });
  }

  actionTriggered() {
    this.isLoader.set(true);
    const retriggerObj = {
      entityId: this.webhookEventLogDetails?.entityId,
      eventId: this.webhookEventLogDetails?.eventId,
      subscriptionId: this.webhookEventLogDetails?.subscriptionId,
    };

    this.developerService.retriggerWebhookEventLogAction(retriggerObj).subscribe({
      next: (_res: any) => {
        this.viewWebHookDetailsGet(this.logId);
        this.toasterService.showSuccess(MessageConstants.developer.RetriggerSuccess, 'full');
      },
      error: (e: any) => {
        this.isLoader.set(false);
        const toastMessage = Exception.exceptionMessage(e);
        this.toasterService.showError(toastMessage.join(', '), 'full');
      },
    });
  }

  backToWebhookEvents() {
    this.router.navigate(['/ally/webhook-events']);
  }
}
